"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetClientAgreementList = void 0;
const Base_1 = require("./Base");
exports.GetClientAgreementList = {
    url: Base_1.URL_BASE + "/GetClientAgreementList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetClientAgreementList.js.map